
import NumberHelpers from '../helpers/NumberHelpers'


export default class {
    static moveItem(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
    }

    static randomFromArray(arr) {
        let random = NumberHelpers.randomInt(arr.length) - 1
        return arr[random]
    }

    static pushUnique(item, array) {
        if(array.indexOf(item) == -1)
            array.push(item)
    }

    static unshiftUnique(item, array) {
        if(array.indexOf(item) == -1)
            array.unshift(item)
    }

    static deleteItem(item, array) {
        let idx = array.indexOf(item)
        if(idx > -1)
            array.splice(idx, 1)
    }

    static textInArray(text, array) {
        let result = false
        array.forEach(item => {
            if(item.indexOf(text) > -1)
                result = true
        })
        return result
    }
    
    static textContainsAnyItem(text, array) {
        let result = false
        array.forEach(item => {
            if(text.indexOf(item) > -1)
                result = true
        })
        return result
    }

    static findByName (arr, name) {
        let obj = arr.find(o => o.name == name)
        if(!obj) {
            console.log('ArrayHelpers > findByName couldnt find the name ' + name + ' in ', arr)
            return null
        }
        return obj
    }

    static toggleInArray(arr, str) {
        //mutates array...
        let pos = arr.indexOf(str)
        if(pos > -1)
            arr.splice(pos,1)
        else
            arr.push(str)
    }
    
}


// WEBPACK FOOTER //
// ./src/helpers/ArrayHelpers.js